import { components } from 'react-select-3';

export const ClearIndicator = props => {
  return <components.ClearIndicator {...props}>×</components.ClearIndicator>;
};
